// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Wizard Styles */

/* Save & Cancel Button */

.app_sNcButtonContainer__DanzK {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    margin-top: 10px;
}

.app_saveButton__W6697 {
    padding: 10px 15px;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
}

.app_saveButton__W6697:hover {
    background-color: #0056b3;
}

.app_cancelButton__j0OVk {
    padding: 10px 15px;
    background-color: #ccc;
    color: black;
    border: none;
    border-radius: 4px;
    cursor: pointer;
}

.app_cancelButton__j0OVk:hover {
    background-color: #b3b3b3;
}

/* Edit & Delete Button */

.app_actionButtonsContainer__gbc5r {
    position: absolute;
    top: 10px;
    right: 10px;
    display: flex;
    gap: 10px;
}

.app_deleteButton__ymhj5 {
    padding: 5px 10px;
    background-color: red;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
}

.app_deleteButton__ymhj5:hover {
    background-color: darkred;
}

.app_editButton__KOzUO {
    padding: 5px 10px;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
}

.app_editButton__KOzUO:hover {
    background-color: #0056b3;
}

/* Add New Button */

.app_addNewButton__RwWPQ {
    width: 100%;
    padding: 10px;
    margin-top: 15px;
    font-size: 16px;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
}

.app_addNewButton__RwWPQ:hover {
    background-color: #0056b3;
}

/* Labels  */

.app_centeredHeading__2\\+OWa {
    text-align: center;
    margin-top: 10px;
    color: #B000EB;
    font-weight: 600;
}

/* Inline alerts */

.app_inlineAlerts__AYtQ- {
    color: red;
    font-size: 0.9em;
}

/* Main Container */

.app_mainContainer__-GDPu {
    border: 1px solid #ccc;
    padding: 10px;
    margin-bottom: 10px;
    border-radius: 5px;
    background-color: #f9f9f9;
    position: relative;
}

.app_editMainContainer__Kvdxs {
    border: 1px solid #ccc;
    padding: 10px;
    border-radius: 5px;
    background-color: #f9f9f9;
}

.app_requiredField__pqAB6 {
    color: red;
}

.app_textBox__PUF3p {
    width: 100%;
    padding: 8px;
    font-size: 14px;
    font-family: 'Arial', sans-serif;
    color: #000000;
    background: #fff;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-sizing: border-box;
    margin-bottom: 15px;
    margin-top: 10px;
    resize: vertical;
    white-space: pre-wrap;
}

.app_schemaProperties__-L77i {
    width: 100%;
    border-collapse: collapse;
    margin-top: 10px;
    margin-bottom: 20px;
}

.app_tableHeading__I\\+1jy {
    border: 1px solid #ccc;
    padding: 8px;
    text-align: center;
}

.app_tableContents__oHybE {
    border: 1px solid #ccc;
    padding: 8px;
    text-align: center;
}

.app_propertyButton__1u63M {
    padding: 10px;
    margin-top: 10px;
    margin-bottom: 10px;
    margin-left: 10px;
    background-color: green;
    color: white;
    border: 4px;
    border-radius: 4px;
    cursor: pointer;
}

/* Popup Container */

.app_popupOverlay__54tGU {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    /* Dark overlay */
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.app_popup__0GFbg {
    background-color: white;
    padding: 20px;
    border-radius: 10px;
    text-align: center;
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
    max-width: 400px;
    width: 90%;
}

.app_popup__0GFbg h3 {
    margin-bottom: 15px;
    font-size: 18px;
    color: #333;
}

.app_popup__0GFbg p {
    margin-bottom: 20px;
    font-size: 14px;
    color: #555;
}

.app_popupButton__Yrqiu {
    padding: 10px 15px;
    font-size: 14px;
    background-color: #007bff;
    /* Bootstrap primary blue */
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
}

.app_popupButton__Yrqiu:hover {
    background-color: #0056b3;
    /* Darker blue on hover */
}

.app_removeIcon__wTXDd {
    background-color: red;
    color: white;
    border: none;
    border-radius: 50%;
    cursor: pointer;
    font-size: 14px;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.app_multiInputForm__iResk {
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 4px;
}

.app_multiInputFormContainer__zK1aA {
    margin-bottom: 10px;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
    background-color: #f9f9f9;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 80px;
    gap: 10px;
    align-items: center;
}

.app_style1__lOyPn {
    width: 100%;
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 4px;
    margin-bottom: 10px;
    box-sizing: border-box;
}

.app_style2__0SfiQ {
    border: 1px solid #ccc;
    padding: 20px;
    border-radius: 4px;
    margin-bottom: 10px;
}

.app_style3__GWQW- {
    margin-bottom: 10px;
}

.app_style4__OWG-I {
    margin-top: 10px;
}

.app_style5__pSCqF {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-left: 10px;
    margin-bottom: 10px;
    margin-top: 10px;
}

.app_checkBoxContents__IrUCS {
    display: flex;
    align-items: center;
    gap: 5px;
}

.app_reqStyle__Q\\+vcW {
    font-size: 12px;
    margin: 0;
}

.app_jsonExample__Wd1-j {
    background-color: #272822;
    color: #FFD700;
    padding: 10px;
    border-radius: 4px;
    overflow-x: auto;
    font-size: 14px;
    line-height: 1.5;
}

.app_dropdown__AOFqD {
    width: 100%;
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 4px;
    margin-bottom: 10px;
    font-size: 14px;
    margin-top: 10px;
}

.app_overlay__FCZrT {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 999;
}

.app_popupContainer__XVs5B {
    position: fixed;
    top: 10%;
    left: 10%;
    width: 30%;
    background-color: white;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    border-radius: 8px;
    padding: 20px;
    z-index: 1000;
}

.app_labelStyle__f3TvT {
    display: block;
    margin-bottom: 5px;
}

.app_infoText__mwV5r {
    font-style: italic;
    color: #666;
}

.app_checkBoxcontainer__bxmae {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-top: 10px;
}

.app_acknowledgeButton__skIg4 {
    padding: 10px;
    background-color: #f9a825;
    color: black;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    flex: 1 1;
    font-size: 14px;
}

.app_style6__HJxUv {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border: 1px solid #ddd;
    border-radius: 4px;
    padding: 10px;
    margin-bottom: 10px;
}

.app_disabledButton__ixakw {
    background-color: #ccc !important;
    color: #666 !important;
    cursor: not-allowed !important;
    opacity: 0.6;
}

.app_securityScopeName__yQ-Ti {
    margin-right: 10px;
    font-weight: bold;
}

.app_securityScopeDesc__xKRj5 {
    margin-right: 10px;
}

/* Button for adding a new scope */
.app_securityAddScopeButton__7vg7a {
    margin-top: 10px;
    padding: 8px 15px;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
}

.app_securityAddScopeButton__7vg7a.app_disabled__\\+-ZAQ {
    background-color: #ccc;
    cursor: not-allowed;
}

.app_securityScopeFields__ipWxr {
    margin-top: 10px;
}

.app_securityScopeSelect__Cl2BT {
    width: 50%;
    padding: 8px;
    margin-right: 10px;
    border-radius: 4px;
    border: 1px solid #ccc;
}

.app_securityScopeInput__qbvJO {
    width: 50%;
    padding: 8px;
    margin-right: 10px;
    border-radius: 4px;
    border: 1px solid #ccc;
}

.app_securityAddScopeFieldButton__xf8zX {
    padding: 8px 15px;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
}

.app_securityAllScopesDefined__Bd0-A {
    margin-top: 10px;
    font-style: italic;
    color: gray;
}

.app_securityFlows__pn5rt {
    margin-left: 15px;
}


.app_agreementContainer__us8L1 {
    max-width: 1200px;
    width: 100%;
    padding: 20px;
    text-align: center;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.app_agreementContent__1G1vJ {
    padding: 20px;
    text-align: left;
    background-color: #f9f9f9;
    border-radius: 5px;
    margin-bottom: 20px;
    max-height: 500px;
    overflow-y: auto;
    width: 95%;
}

.app_agreementContent__1G1vJ iframe {
    width: 100%;
    height: 400px;
    border: none;
}

.app_buttonContainer__5C4vx {
    display: flex;
    justify-content: space-between;
}

.app_agreeButton__omwws,
.app_disagreeButton__fkOYU {
    padding: 10px 20px;
    font-size: 16px;
    border: none;
    cursor: pointer;
    border-radius: 5px;
    color: white;
    transition: 0.3s ease;
}

.app_agreeButton__omwws {
    background-color: #28a745;
}

.app_agreeButton__omwws:hover {
    background-color: #218838;
}

.app_disagreeButton__fkOYU {
    background-color: #dc3545;
}

.app_disagreeButton__fkOYU:hover {
    background-color: #c82333;
}
`, "",{"version":3,"sources":["webpack://./src/app.module.css"],"names":[],"mappings":"AAAA,kBAAkB;;AAElB,yBAAyB;;AAEzB;IACI,aAAa;IACb,yBAAyB;IACzB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,yBAAyB;;AAEzB;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,aAAa;IACb,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;IACrB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,mBAAmB;;AAEnB;IACI,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,YAAY;;AAEZ;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;;AAEA,kBAAkB;;AAElB;IACI,UAAU;IACV,gBAAgB;AACpB;;AAEA,mBAAmB;;AAEnB;IACI,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,aAAa;IACb,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gCAAgC;IAChC,cAAc;IACd,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,uBAAuB;IACvB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,eAAe;AACnB;;AAEA,oBAAoB;;AAEpB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,iBAAiB;IACjB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,0CAA0C;IAC1C,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,2BAA2B;IAC3B,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,yBAAyB;IACzB,aAAa;IACb,+CAA+C;IAC/C,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,aAAa;IACb,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,SAAS;IACT,UAAU;IACV,uBAAuB;IACvB,wCAAwC;IACxC,kBAAkB;IAClB,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,SAAO;IACP,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,iCAAiC;IACjC,sBAAsB;IACtB,8BAA8B;IAC9B,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA,kCAAkC;AAClC;IACI,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,iBAAiB;AACrB;;;AAGA;IACI,iBAAiB;IACjB,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;IAClB,2CAA2C;IAC3C,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;;IAEI,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":["/* Wizard Styles */\n\n/* Save & Cancel Button */\n\n.sNcButtonContainer {\n    display: flex;\n    justify-content: flex-end;\n    gap: 10px;\n    margin-top: 10px;\n}\n\n.saveButton {\n    padding: 10px 15px;\n    background-color: #007bff;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n}\n\n.saveButton:hover {\n    background-color: #0056b3;\n}\n\n.cancelButton {\n    padding: 10px 15px;\n    background-color: #ccc;\n    color: black;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n}\n\n.cancelButton:hover {\n    background-color: #b3b3b3;\n}\n\n/* Edit & Delete Button */\n\n.actionButtonsContainer {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    display: flex;\n    gap: 10px;\n}\n\n.deleteButton {\n    padding: 5px 10px;\n    background-color: red;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n}\n\n.deleteButton:hover {\n    background-color: darkred;\n}\n\n.editButton {\n    padding: 5px 10px;\n    background-color: #007bff;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n}\n\n.editButton:hover {\n    background-color: #0056b3;\n}\n\n/* Add New Button */\n\n.addNewButton {\n    width: 100%;\n    padding: 10px;\n    margin-top: 15px;\n    font-size: 16px;\n    background-color: #007bff;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n}\n\n.addNewButton:hover {\n    background-color: #0056b3;\n}\n\n/* Labels  */\n\n.centeredHeading {\n    text-align: center;\n    margin-top: 10px;\n    color: #B000EB;\n    font-weight: 600;\n}\n\n/* Inline alerts */\n\n.inlineAlerts {\n    color: red;\n    font-size: 0.9em;\n}\n\n/* Main Container */\n\n.mainContainer {\n    border: 1px solid #ccc;\n    padding: 10px;\n    margin-bottom: 10px;\n    border-radius: 5px;\n    background-color: #f9f9f9;\n    position: relative;\n}\n\n.editMainContainer {\n    border: 1px solid #ccc;\n    padding: 10px;\n    border-radius: 5px;\n    background-color: #f9f9f9;\n}\n\n.requiredField {\n    color: red;\n}\n\n.textBox {\n    width: 100%;\n    padding: 8px;\n    font-size: 14px;\n    font-family: 'Arial', sans-serif;\n    color: #000000;\n    background: #fff;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    box-sizing: border-box;\n    margin-bottom: 15px;\n    margin-top: 10px;\n    resize: vertical;\n    white-space: pre-wrap;\n}\n\n.schemaProperties {\n    width: 100%;\n    border-collapse: collapse;\n    margin-top: 10px;\n    margin-bottom: 20px;\n}\n\n.tableHeading {\n    border: 1px solid #ccc;\n    padding: 8px;\n    text-align: center;\n}\n\n.tableContents {\n    border: 1px solid #ccc;\n    padding: 8px;\n    text-align: center;\n}\n\n.propertyButton {\n    padding: 10px;\n    margin-top: 10px;\n    margin-bottom: 10px;\n    margin-left: 10px;\n    background-color: green;\n    color: white;\n    border: 4px;\n    border-radius: 4px;\n    cursor: pointer;\n}\n\n/* Popup Container */\n\n.popupOverlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.5);\n    /* Dark overlay */\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n}\n\n.popup {\n    background-color: white;\n    padding: 20px;\n    border-radius: 10px;\n    text-align: center;\n    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);\n    max-width: 400px;\n    width: 90%;\n}\n\n.popup h3 {\n    margin-bottom: 15px;\n    font-size: 18px;\n    color: #333;\n}\n\n.popup p {\n    margin-bottom: 20px;\n    font-size: 14px;\n    color: #555;\n}\n\n.popupButton {\n    padding: 10px 15px;\n    font-size: 14px;\n    background-color: #007bff;\n    /* Bootstrap primary blue */\n    color: white;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n}\n\n.popupButton:hover {\n    background-color: #0056b3;\n    /* Darker blue on hover */\n}\n\n.removeIcon {\n    background-color: red;\n    color: white;\n    border: none;\n    border-radius: 50%;\n    cursor: pointer;\n    font-size: 14px;\n    width: 24px;\n    height: 24px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.multiInputForm {\n    padding: 8px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n}\n\n.multiInputFormContainer {\n    margin-bottom: 10px;\n    padding: 10px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    background-color: #f9f9f9;\n    display: grid;\n    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 80px;\n    gap: 10px;\n    align-items: center;\n}\n\n.style1 {\n    width: 100%;\n    padding: 8px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    margin-bottom: 10px;\n    box-sizing: border-box;\n}\n\n.style2 {\n    border: 1px solid #ccc;\n    padding: 20px;\n    border-radius: 4px;\n    margin-bottom: 10px;\n}\n\n.style3 {\n    margin-bottom: 10px;\n}\n\n.style4 {\n    margin-top: 10px;\n}\n\n.style5 {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    margin-left: 10px;\n    margin-bottom: 10px;\n    margin-top: 10px;\n}\n\n.checkBoxContents {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n}\n\n.reqStyle {\n    font-size: 12px;\n    margin: 0;\n}\n\n.jsonExample {\n    background-color: #272822;\n    color: #FFD700;\n    padding: 10px;\n    border-radius: 4px;\n    overflow-x: auto;\n    font-size: 14px;\n    line-height: 1.5;\n}\n\n.dropdown {\n    width: 100%;\n    padding: 8px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    margin-bottom: 10px;\n    font-size: 14px;\n    margin-top: 10px;\n}\n\n.overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.5);\n    z-index: 999;\n}\n\n.popupContainer {\n    position: fixed;\n    top: 10%;\n    left: 10%;\n    width: 30%;\n    background-color: white;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n    border-radius: 8px;\n    padding: 20px;\n    z-index: 1000;\n}\n\n.labelStyle {\n    display: block;\n    margin-bottom: 5px;\n}\n\n.infoText {\n    font-style: italic;\n    color: #666;\n}\n\n.checkBoxcontainer {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 10px;\n    margin-top: 10px;\n}\n\n.acknowledgeButton {\n    padding: 10px;\n    background-color: #f9a825;\n    color: black;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    flex: 1;\n    font-size: 14px;\n}\n\n.style6 {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    padding: 10px;\n    margin-bottom: 10px;\n}\n\n.disabledButton {\n    background-color: #ccc !important;\n    color: #666 !important;\n    cursor: not-allowed !important;\n    opacity: 0.6;\n}\n\n.securityScopeName {\n    margin-right: 10px;\n    font-weight: bold;\n}\n\n.securityScopeDesc {\n    margin-right: 10px;\n}\n\n/* Button for adding a new scope */\n.securityAddScopeButton {\n    margin-top: 10px;\n    padding: 8px 15px;\n    background-color: #007bff;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n}\n\n.securityAddScopeButton.disabled {\n    background-color: #ccc;\n    cursor: not-allowed;\n}\n\n.securityScopeFields {\n    margin-top: 10px;\n}\n\n.securityScopeSelect {\n    width: 50%;\n    padding: 8px;\n    margin-right: 10px;\n    border-radius: 4px;\n    border: 1px solid #ccc;\n}\n\n.securityScopeInput {\n    width: 50%;\n    padding: 8px;\n    margin-right: 10px;\n    border-radius: 4px;\n    border: 1px solid #ccc;\n}\n\n.securityAddScopeFieldButton {\n    padding: 8px 15px;\n    background-color: #007bff;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n}\n\n.securityAllScopesDefined {\n    margin-top: 10px;\n    font-style: italic;\n    color: gray;\n}\n\n.securityFlows {\n    margin-left: 15px;\n}\n\n\n.agreementContainer {\n    max-width: 1200px;\n    width: 100%;\n    padding: 20px;\n    text-align: center;\n    background-color: #fff;\n    border-radius: 8px;\n    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n}\n\n.agreementContent {\n    padding: 20px;\n    text-align: left;\n    background-color: #f9f9f9;\n    border-radius: 5px;\n    margin-bottom: 20px;\n    max-height: 500px;\n    overflow-y: auto;\n    width: 95%;\n}\n\n.agreementContent iframe {\n    width: 100%;\n    height: 400px;\n    border: none;\n}\n\n.buttonContainer {\n    display: flex;\n    justify-content: space-between;\n}\n\n.agreeButton,\n.disagreeButton {\n    padding: 10px 20px;\n    font-size: 16px;\n    border: none;\n    cursor: pointer;\n    border-radius: 5px;\n    color: white;\n    transition: 0.3s ease;\n}\n\n.agreeButton {\n    background-color: #28a745;\n}\n\n.agreeButton:hover {\n    background-color: #218838;\n}\n\n.disagreeButton {\n    background-color: #dc3545;\n}\n\n.disagreeButton:hover {\n    background-color: #c82333;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sNcButtonContainer": `app_sNcButtonContainer__DanzK`,
	"saveButton": `app_saveButton__W6697`,
	"cancelButton": `app_cancelButton__j0OVk`,
	"actionButtonsContainer": `app_actionButtonsContainer__gbc5r`,
	"deleteButton": `app_deleteButton__ymhj5`,
	"editButton": `app_editButton__KOzUO`,
	"addNewButton": `app_addNewButton__RwWPQ`,
	"centeredHeading": `app_centeredHeading__2+OWa`,
	"inlineAlerts": `app_inlineAlerts__AYtQ-`,
	"mainContainer": `app_mainContainer__-GDPu`,
	"editMainContainer": `app_editMainContainer__Kvdxs`,
	"requiredField": `app_requiredField__pqAB6`,
	"textBox": `app_textBox__PUF3p`,
	"schemaProperties": `app_schemaProperties__-L77i`,
	"tableHeading": `app_tableHeading__I+1jy`,
	"tableContents": `app_tableContents__oHybE`,
	"propertyButton": `app_propertyButton__1u63M`,
	"popupOverlay": `app_popupOverlay__54tGU`,
	"popup": `app_popup__0GFbg`,
	"popupButton": `app_popupButton__Yrqiu`,
	"removeIcon": `app_removeIcon__wTXDd`,
	"multiInputForm": `app_multiInputForm__iResk`,
	"multiInputFormContainer": `app_multiInputFormContainer__zK1aA`,
	"style1": `app_style1__lOyPn`,
	"style2": `app_style2__0SfiQ`,
	"style3": `app_style3__GWQW-`,
	"style4": `app_style4__OWG-I`,
	"style5": `app_style5__pSCqF`,
	"checkBoxContents": `app_checkBoxContents__IrUCS`,
	"reqStyle": `app_reqStyle__Q+vcW`,
	"jsonExample": `app_jsonExample__Wd1-j`,
	"dropdown": `app_dropdown__AOFqD`,
	"overlay": `app_overlay__FCZrT`,
	"popupContainer": `app_popupContainer__XVs5B`,
	"labelStyle": `app_labelStyle__f3TvT`,
	"infoText": `app_infoText__mwV5r`,
	"checkBoxcontainer": `app_checkBoxcontainer__bxmae`,
	"acknowledgeButton": `app_acknowledgeButton__skIg4`,
	"style6": `app_style6__HJxUv`,
	"disabledButton": `app_disabledButton__ixakw`,
	"securityScopeName": `app_securityScopeName__yQ-Ti`,
	"securityScopeDesc": `app_securityScopeDesc__xKRj5`,
	"securityAddScopeButton": `app_securityAddScopeButton__7vg7a`,
	"disabled": `app_disabled__+-ZAQ`,
	"securityScopeFields": `app_securityScopeFields__ipWxr`,
	"securityScopeSelect": `app_securityScopeSelect__Cl2BT`,
	"securityScopeInput": `app_securityScopeInput__qbvJO`,
	"securityAddScopeFieldButton": `app_securityAddScopeFieldButton__xf8zX`,
	"securityAllScopesDefined": `app_securityAllScopesDefined__Bd0-A`,
	"securityFlows": `app_securityFlows__pn5rt`,
	"agreementContainer": `app_agreementContainer__us8L1`,
	"agreementContent": `app_agreementContent__1G1vJ`,
	"buttonContainer": `app_buttonContainer__5C4vx`,
	"agreeButton": `app_agreeButton__omwws`,
	"disagreeButton": `app_disagreeButton__fkOYU`
};
export default ___CSS_LOADER_EXPORT___;
